// assets.tsx — table header columns
export const ASSETS_UPLOAD_DATE_TIME_TEXT = {
    id: 'oe.assets.uploadDateAndTime',
    description: 'Label text',
    defaultMessage: 'Upload Date & Time',
};

export const ASSETS_FILE_NAME_TEXT = {
    id: 'oe.assets.fileName',
    description: 'Label text',
    defaultMessage: 'File Name',
};

export const ASSETS_LINK_TEXT = {
    id: 'oe.assets.link',
    description: 'Label text',
    defaultMessage: 'Link',
};

// assets.tsx — upload toolbar
export const ASSETS_DRAG_DROP_HINT_TEXT = {
    id: 'oe.uploadedFileType.dragAndDropFile',
    description: 'Label text',
    defaultMessage: 'Or drag-and-drop {value}',
};

export const ASSETS_FILE_TYPE_TEXT = {
    id: 'oe.uploadedFileType.assets',
    description: 'file type',
    defaultMessage: 'files',
};

export const ASSETS_UPLOAD_FILES_TEXT = {
    id: 'oe.assets.uploadFiles',
    description: 'Button label',
    defaultMessage: '{prefix} Upload Files',
};

// assets-list-item.tsx — upload state
export const ASSETS_DROP_ZONE_TEXT = {
    id: 'oe.assets.dragAndDropFiles',
    description: 'Drop zone label',
    defaultMessage: 'Drag-and-drop files',
};

export const ASSETS_UPLOADING_TEXT = {
    id: 'oe.assets.uploading',
    description: 'Upload in progress label',
    defaultMessage: 'Uploading',
};

// assets-speaker-item.tsx
export const ASSETS_PROFILE_IMAGE_TEXT = {
    id: 'oe.attendee.profileImage',
    description: 'Label text',
    defaultMessage: 'Profile Image',
};

export const ASSETS_DROP_TO_REPLACE_TEXT = {
    id: 'oe.assets.dropToReplaceProfileImage',
    description: 'Button label',
    defaultMessage: 'Drop to replace Profile Image',
};

export const ASSETS_DROP_TO_ADD_TEXT = {
    id: 'oe.assets.dropToAddProfileImage',
    description: 'Button label',
    defaultMessage: 'Drop to add Profile Image',
};

export const ASSETS_ADD_PROFILE_IMAGE_TEXT = {
    id: 'oe.assets.addProfileImage',
    description: 'Button label',
    defaultMessage: '+ Add Profile Image',
};

export const ASSETS_ADDED_TEXT = {
    id: 'oe.assets.added',
    description: 'Label text',
    defaultMessage: 'Added',
};

// assets-biography-item.tsx
export const ASSETS_BIOGRAPHY_TEXT = {
    id: 'oe.attendee.biography',
    description: 'Label text',
    defaultMessage: 'Biography',
};

export const ASSETS_BIOGRAPHY_UPDATED_TEXT = {
    id: 'oe.assets.biographyUpdated',
    description: 'Label text',
    defaultMessage: 'Biography Updated',
};